import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbDateAdapter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';

import { AnalyticsService as SharedAnalyticsService } from '@shared/analytics/services';
import {
  CapitalizePipe,
  CommonRadioGroupModule,
  CustomAdapter,
  UtilsModule,
  CustomDateParserFormatterProvider,
} from '@tablesready/common-ui';
import { AnalyticsComponent } from './analytics.component';
import { AnalyticsRoutingModule } from './analytics.routing.module';
import { StatisticsComponent, ServicesAndResourcesStatisticsComponent } from './components';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AppVariablesModule } from '@tablesready/frontend-variables';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    AnalyticsComponent,
    StatisticsComponent,
    ServicesAndResourcesStatisticsComponent,
  ],
  imports: [
    CommonModule,
    CommonRadioGroupModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AppVariablesModule,
    AlertsModule,
    StatusModule,
    AuthModule,
    AnalyticsRoutingModule,
    NgChartsModule,
    UtilsModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendPullRefreshModule,
  ],
  providers: [
    CapitalizePipe,
    SharedAnalyticsService,
    CustomDateParserFormatterProvider,
    {
      provide: NgbDateAdapter,
      useClass: CustomAdapter,
    },
  ],
})
export class AnalyticsModule {}
